"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.goalToString = exports.Goal = void 0;
var Goal;
(function (Goal) {
    Goal["LAUNCHING_BUSINESS"] = "LAUNCHING_BUSINESS";
    Goal["CUSTOMER_INCREASE"] = "CUSTOMER_INCREASE";
    Goal["MAINTAIN_BUSINESS"] = "MAINTAIN_BUSINESS ";
    Goal["BOTH_MAINTAIN"] = "BOTH_MAINTAIN";
})(Goal || (exports.Goal = Goal = {}));
exports.goalToString = {
    [Goal.LAUNCHING_BUSINESS]: "I am just launching my business",
    [Goal.CUSTOMER_INCREASE]: "I need to increase customers",
    [Goal.MAINTAIN_BUSINESS]: "I need to maintain my current business",
    [Goal.BOTH_MAINTAIN]: "Both maintain my customers and increase business",
};
